export default __webpack_public_path__ + "static/wires-e7e64bad82656220a907c3af91a0490b.png";